import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart, Plus } from 'lucide-react';
import { useCart } from '../../context/CartContext';

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();

  const handleAddToCart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addToCart(product);
  };

  return (
    <Link
      to={`/product/${product.slug}`}
      className="group flex flex-col bg-white rounded-2xl overflow-hidden border border-dark-100 shadow-sm hover:shadow-card-hover hover:border-athletic-200 transition-all duration-300"
    >
      {/* Image */}
      <div className="aspect-square bg-dark-50 relative overflow-hidden">
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        {product.badge && (
          <span className="absolute top-3 left-3 px-3 py-1 text-white text-[11px] font-bold uppercase tracking-wide rounded-full bg-gradient-to-r from-athletic-500 to-power-600 shadow">
            {product.badge}
          </span>
        )}
        <button
          onClick={handleAddToCart}
          aria-label="Add to cart"
          className="absolute bottom-3 right-3 w-10 h-10 flex items-center justify-center bg-dark-900 text-white rounded-xl shadow-lg opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300 hover:bg-athletic-600"
        >
          <Plus className="w-5 h-5" />
        </button>
      </div>

      {/* Info */}
      <div className="p-5 flex flex-col flex-grow">
        <p className="text-[11px] font-semibold uppercase tracking-wider text-athletic-600 mb-1.5">
          {product.categorySlug?.replace(/-/g, ' ')}
        </p>
        <h3 className="font-semibold text-dark-900 mb-3 group-hover:text-athletic-600 transition-colors line-clamp-2 flex-grow">
          {product.name}
        </h3>
        <div className="flex items-center justify-between mt-auto">
          <p className="text-xl font-bold text-dark-900">${product.price.toFixed(2)}</p>
          <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-athletic-700 group-hover:gap-2.5 transition-all">
            <ShoppingCart className="w-4 h-4" /> Add
          </span>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
